import { useState } from 'react';
import { string, node, bool } from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  /* z-index: 0; */
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

const LinkBtn = styled.span`
  font-size: 1rem;
  cursor: pointer;
  color: ${({theme}) => theme.colors.link};

  &:hover {
    color: $${({theme}) => theme.colors.link_hover}
  }
`;

const Title = styled.p`
  margin: 0px;
  font-size: 16px;
  border-left: 0px;
  padding-left: 0px;
  font-weight: bold;
`;

const SectionWrapper = styled.div`
    background-color: ${({theme}) => theme.colors.white};
    box-shadow: rgb(214 217 223) 0px 0px 4px;
    margin-bottom: 1.5rem;
    /* border-radius: 5px; */
    padding: 1.5rem 2rem;
    height: ${({collapsed}) => collapsed ? '90px' : 'auto'};
    position: relative;
    overflow: ${({collapsed}) => collapsed ? 'hidden' : 'visible'};
    overflow-x: auto;

    ${({collapsed}) => collapsed &&
    `
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        height: 70%;
        width: 100%;
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%);
        z-index: 0;
      }`
    }
`;

function Section({title, isCollapsible, defaultCollapsedState, children}) {
  const [collapsed, setCollapsed] = useState(isCollapsible && defaultCollapsedState);

  return (
    <Wrapper>
      <TitleWrapper>
        <Title>{title}</Title>
        {
          isCollapsible && (
            <LinkBtn onClick={() => setCollapsed(prev => !prev)}>{collapsed ? 'show more': 'show less'}</LinkBtn>
          )
        }
      </TitleWrapper>
      <SectionWrapper collapsed={collapsed}>
        {children}
      </SectionWrapper>
    </Wrapper>
  );
}

Section.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  isCollapsible: bool,
  defaultCollapsedState: bool,

};

Section.defaultProps = {
  isCollapsible: true,
  defaultCollapsedState: true,
}

export default Section;